import { METHOD } from 'services/method'

export const API_RETURN_POLICY = {
    DETAIL: {
        api: '/v1/dashboard-admin/more-info/return-policy',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/more-info/return-policy',
        method: METHOD.PUT,
    },
}
